interface IIconProps {
  size?: number;
  color?: string;
  circleColor?: string;
}

export const FrontDeskIcon = ({ size = 46, color = '#83B2BE', circleColor = '#E7F0F3' }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="22.8571" cy="22.8571" r="22.8571" fill={circleColor} />
    <g clipPath="url(#clip0_861_10769)">
      <path
        d="M22.3936 11.0601H26.4738C27.0348 11.0601 27.4938 10.6011 27.4938 10.0401V8H21.3735V10.0401C21.3735 10.6011 21.8326 11.0601 22.3936 11.0601Z"
        fill={color}
      />
      <path
        d="M29.5335 8V10.0401C29.5335 11.7232 28.1565 13.1002 26.4734 13.1002H22.3932C20.7102 13.1002 19.3331 11.7232 19.3331 10.0401V8C17.0788 8 15.2529 9.82588 15.2529 12.0802V20.4139L16.9972 22.1582C17.5786 22.7396 17.8948 23.5047 17.8948 24.3207C17.8948 25.0755 17.6194 25.7998 17.1196 26.3608L19.3433 28.5845C19.9043 28.0847 20.6184 27.8093 21.3834 27.8093C22.1994 27.8093 22.9645 28.1255 23.5459 28.7069L26.1878 31.3488C26.7692 31.9302 27.0854 32.6953 27.0854 33.5113C27.0854 34.3273 26.7692 35.0924 26.1878 35.6738L25.2902 36.5714H29.5437C31.798 36.5714 33.6239 34.7456 33.6239 32.4913V12.0802C33.6239 9.82588 31.798 8 29.5437 8H29.5335Z"
        fill={color}
      />
      <path
        d="M22.0971 30.1457C21.6993 29.7479 21.0567 29.7479 20.6589 30.1457L19.343 31.4616L14.2428 26.3614L15.5587 25.0455C15.9565 24.6477 15.9565 24.0051 15.5587 23.6073L12.9167 20.9654C12.5189 20.5675 11.8763 20.5675 11.4785 20.9654L10.336 22.1078C9.571 22.8728 9.14258 23.9133 9.14258 24.9945V25.6984C9.14258 26.7796 9.571 27.82 10.336 28.5851L17.1295 35.3786C17.8946 36.1436 18.935 36.572 20.0162 36.572H20.7201C21.8013 36.572 22.8418 36.1436 23.6068 35.3786L24.7492 34.2361C25.1471 33.8383 25.1471 33.1957 24.7492 32.7979L22.1073 30.1559H22.0971V30.1457Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_861_10769">
        <rect width="24.4811" height="28.5714" fill="white" transform="translate(9.14258 8)" />
      </clipPath>
    </defs>
  </svg>
);
